<template>
<Container>
	<Header title="The Business Growth Fund" :homepage-url="homepageUrl">
		<template #logo>
			<BGFLogo />
		</template>
	</Header>
	<Nav v-if="isAuthenticated && routeRequiresAuth" @btnClick="logoutAndRedirect" />
	<main>
		<div class="view-wrap">
			<Heading :level="1" text="The Business Growth Fund is now closed" />
			<p>We are no longer accepting any new applications.</p>
			<p>Thank you for you interest.</p>
		</div>
	</main>
	<LogoBar v-if="logos" :logos="logos" />
	<Footer class="flex wrap-mob space-between justify-center align-center">
		<template #poweredBy>
			<div class="legal-links flex wrap justify-center align-center justify-start-dt">
				<p class="color-white">Copyright&copy; {{ new Date().getFullYear() }}</p>
				<a href="https://www.businessgrowth.fund/privacy" target="_blank" rel="nofollow noopener">Privacy Policy</a>
				<router-link :to="{name: 'faq'}" target="_blank">FAQ's</router-link>
				<small>V{{ version }}</small>
			</div>
		</template>
		<UMiLogo />
	</Footer>
	<content-overlay v-if="getInterstitial.isLoading">
		<template #content>
			<Interstitial v-if="getInterstitial.isLoading" :loading-message="getInterstitial.message" />
		</template>
	</content-overlay>
	<div id="modals" />
	<notifications />
</Container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import LogoBar from '@/components/LogoBar';
import UMiLogo from '@/components/Icons/UMiLogo';
import BGFLogo from './components/Icons/BGFLogo';

export default {
	components: {
		LogoBar,
		UMiLogo,
		BGFLogo
	},
	provide () {
		return {
			stageOneSteps: this.stageOneSteps,
			stageTwoSteps: this.stageTwoSteps,
			claimSteps: this.claimSteps
		};
	},
	data () {
		return {
			version: process.env.VUE_APP_VERSION,

			stageOneSteps: [
				{ dynamicsId: 'ContactDetailsEOI', pathName: 'ContactDetailsEOI', name: 'Contact Details' },
				{ dynamicsId: 'BusinessLocation', pathName: 'BusinessLocation', name: 'Business Location' },
				{ dynamicsId: 'BusinessDetailsEOI', pathName: 'BusinessDetailsEOI', name: 'Business Details' },
				{ dynamicsId: 'DeclarationsEOI', pathName: 'DeclarationsEOI', name: 'Declarations' }
			],
			stageTwoSteps: [
				{ dynamicsId: 'CreditSafeDeclaration', pathName: 'CreditSafeDeclaration', name: 'CreditSafe Declaration' },
				{ dynamicsId: 'BusinessDetails', pathName: 'BusinessDetails', name: 'Business Details' },
				{ dynamicsId: 'ContactDetails', pathName: 'ContactDetails', name: 'Contact Details' },
				{ dynamicsId: 'Directors', pathName: 'Directors', name: 'Directors' },
				{ dynamicsId: 'Shareholders', pathName: 'Shareholders', name: 'Shareholders' },
				{ dynamicsId: 'ProjectDetailsOne', pathName: 'ProjectDetailsOne', name: 'Project Details' },
				{ dynamicsId: 'ProjectDetailsTwo', pathName: 'ProjectDetailsTwo', name: 'Project Details - Cont.' },
				{ dynamicsId: 'MarketInformation', pathName: 'MarketInformation', name: 'Market Information' },
				{ dynamicsId: 'ProjectImpacts', pathName: 'ProjectImpacts', name: 'Project Impacts' },
				{ dynamicsId: 'PaymentDetails', pathName: 'PaymentDetails', name: 'Payment Details' },
				{ dynamicsId: 'AdditionalDocuments', pathName: 'AdditionalDocuments', name: 'Additional Documents' },
				{ dynamicsId: 'Declarations', pathName: 'Declarations', name: 'Declarations' }
			],
			claimSteps: [
				{ dynamicsId: 'ClaimDetails', pathName: 'ClaimDetails', name: 'Claim Details' }
			],
			logos: [
				{
					url: '/North_of_Tyne_Combined_Authority_logo.png',
					width: 125,
					height: 125
				},
				{
					url: '/Sunderland-City-Council.png',
					width: 200,
					height: 200
				},
				{
					url: '/Gateshead-Council-Logo-1.png',
					width: 200,
					height: 200
				},
				{
					url: '/funded_by.png',
					width: 200,
					height: 200
				},
				{
					url: '/umi.png',
					width: 85,
					height: 64
				}
			]
		};
	},
	computed: {
		routeRequiresAuth () {
			return this.$route.meta.requiresAuth;
		},
		homepageUrl () {
			return `${process.env.VUE_APP_RELATIVE_URL}dashboard`;
		},
		...mapGetters('auth', ['isAuthenticated']),
		...mapGetters('ui', ['getInterstitial'])

	},
	mounted () {
		// prepare sectors for business details in both EOI and application
		this.setParentSectors();
		this.setSectors();
	},
	methods: {
		logoutAndRedirect () {
			this.logout();
			this.$router.push({ name: 'Login' });
		},
		...mapActions('auth', ['logout']),
		...mapActions('settings', ['setParentSectors', 'setSectors'])
	}
};
</script>
